module.exports = __webpack_public_path__ + "static/media/basketball-court-wood-dimmed.20272a57.jpg";